import {
  AfterContentInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BookingService } from 'src/app/services';
import {
  LevelOfEducation,
  ParentalRole,
  PriceCalculationData,
  ReceivesBafoeg,
} from 'src/app/types';

@Component({
  selector: 'app-step4a-consent-proctoring-modal',
  templateUrl:
    './step4a-consent-proctoring-modal.component.html',
  styleUrls: [
    './step4a-consent-proctoring-modal.component.scss',
  ],
})
export class Step4aConsentProctoringModalComponent
  implements OnInit, AfterContentInit
{
  @Output() stepLoaded: EventEmitter<void> =
    new EventEmitter<void>();

  form!: FormGroup;
  result: { data: boolean } | null = null;
  showBreadcrumb = false;

  @Input() data!: boolean;

  constructor(
    private bookingService: BookingService,
    private fb: FormBuilder,
    public bsModalRef: BsModalRef<Step4aConsentProctoringModalComponent>
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      consent: [false, [Validators.requiredTrue]],
    });
  }

  ngAfterContentInit() {
    this.stepLoaded.emit();
  }

  get consentControl(): FormControl {
    return this.form.get('consent') as FormControl;
  }

  nextAndClose(): void {
    const priceCalculationData: PriceCalculationData = {
      dataProcessingForProctoringAccepted:
        this.consentControl.value,
      parentage: [
        {
          type: ParentalRole.MOTHER,
          levelOfEducation: LevelOfEducation.UNDEFINED,
        },
        {
          type: ParentalRole.FATHER,
          levelOfEducation: LevelOfEducation.UNDEFINED,
        },
      ],
      receivesBafoeg: ReceivesBafoeg.UNKNOWN,
    };

    this.bookingService.formState.item = {
      ...this.bookingService.formState.item,
      priceCalculationData,
    };

    this.result = { data: this.form.valid };
    this.bsModalRef.hide();
  }
}
